import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ExamplePanel from '../Helpers/ExamplePanel';
import Footer from '../Helpers/Footer';
import PageTitleMobile from '../Helpers/PageTitleMobile';
import Sidebar from '../Helpers/Sidebar';
import Toolbar from '../Helpers/Toolbar';
import { connect } from 'react-redux';
import { generalActions } from '../../actions/general.action';
import { configureActions } from '../../actions/configure.action';
import { bindActionCreators } from 'redux';
import Navigation from '../Helpers/Navigation';

function BackendMobile(props) {
  const closeExamplePanel = () => {
    document.body.classList.remove('content-side-open');
  };
  const closeNav = () => {
    document.body.classList.remove('content-side-nav-open');
  };
  return (
    <div className="page-inner">
      {/* <Toolbar /> */}
      {/* <Sidebar /> */}

      <div className="content-side-nav-wrapper">
        <div className="content-side-nav-overlay" onClick={closeNav} />
        <div className="content-side-nav">{/* <Navigation /> */}</div>
      </div>

      <div className="main">
        <PageTitleMobile title={props.title} />

        <div className="content">{props.children}</div>

        <Footer />
      </div>

      <div className="content-side-wrapper">
        <div className="content-side-overlay" onClick={closeExamplePanel} />
        <div className="content-side">
          <ExamplePanel />
        </div>
      </div>
    </div>
  );
}

BackendMobile.propTypes = {
  children: PropTypes.node.isRequired,
};

function mapStateToProps(state) {
  return {
    general: state.general,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BackendMobile);
